<script lang="ts">
    import { trans } from '$assets/shop-translator.js';
    import {
        isModalOpen,
        modalStep,
        snowtrexPendingSelection,
        snowtrexSelectedPax,
    } from '$saga/views/Tour/store';
    import SnowtrexVisibleDates from '$saga/views/Tour/VisibleDates/SnowtrexVisibleDates/SnowtrexVisibleDates.svelte';
    import type {
        SnowtrexAccommodationDate,
        SnowtrexMonthlyPrices,
        SnowtrexSelection,
    } from '$saga/views/Tour/VisibleDates/types';

    export let snowtrexAccommodationDates: SnowtrexAccommodationDate[] = [];
    export let cheapestMonthlyPrices: SnowtrexMonthlyPrices = {};

    const handleAccommodationSelected = (selection: SnowtrexSelection) => {
        snowtrexSelectedPax.set(selection.pax);
        snowtrexPendingSelection.set(selection);
        $modalStep = 2;
        $isModalOpen = true;
    };
</script>

{#if snowtrexAccommodationDates.length > 0}
    <h2 class="pb-m text-[26px] font-semibold medium:text-[32px]">
        {trans('tour.dates.snowtrex.title')}
    </h2>
    <div class="w-full bg-white p-m text-content-neutral">
        <SnowtrexVisibleDates
            {snowtrexAccommodationDates}
            {cheapestMonthlyPrices}
            onAccommodationSelected={handleAccommodationSelected}
        />
    </div>
{/if}
